import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';
import styledNormalize from 'styled-normalize';
import 'typeface-bitter';
import 'typeface-open-sans';
import theme, { ThemeInterface } from './theme';

const {
    default: styled,
    css,
    injectGlobal,
    keyframes,
    ThemeProvider
} = styledComponents as ThemedStyledComponentsModule<ThemeInterface>;

// tslint:disable-next-line:no-unused-expression
injectGlobal`
    ${styledNormalize}

    body {
        font-family: 'Open Sans', sans-serif;
        font-weight: 300;
        padding: 0;
        color: ${theme.text};
    }
    
    a {
    color: ${theme.primary};
    }

    p, div {
        line-height: 1.5;
    }

    input, textarea {
        padding: 0.4em 0;
        box-sizing: border-box;
        border: none;
        border-bottom: 1px solid ${theme.primary};

        &:focus {
            outline-offset: 4px;
        }
    }

    .amplify-nav{
        margin-right: auto !important;
        margin-left: auto !important;
        max-width: 1040px;
        padding-right: 1rem;
        padding-left: 1rem;
    }
`;

export { css, keyframes, ThemeProvider };
export default styled;



// WEBPACK FOOTER //
// ./src/styled-components.ts